import { render, staticRenderFns } from "./SchematicComponent.vue?vue&type=template&id=4607b6dc&scoped=true"
import script from "./SchematicComponent.vue?vue&type=script&lang=js"
export * from "./SchematicComponent.vue?vue&type=script&lang=js"
import style0 from "./SchematicComponent.vue?vue&type=style&index=0&id=4607b6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4607b6dc",
  null
  
)

export default component.exports